






















































































































import { Component, Vue } from "vue-property-decorator";
import emailjs from "@emailjs/browser";

type Status = "idle" | "sending" | "success" | "error";

@Component
export default class ContactForm extends Vue {
  form = {
    name: "",
    email: "",
    phone: "",
    interest: null as string | null,
    message: "",
  };

  status: Status = "idle";
  triedSubmit = false;

  // EmailJS credentials
  private readonly EMAILJS_SERVICE_ID = "service_6econ5r";
  private readonly EMAILJS_TEMPLATE_ID = "template_mv8mtpa";
  private readonly EMAILJS_PUBLIC_KEY = "QvcnQenEgsjwkKlHV";

  get interestOptions() {
    const opts = this.$t(
      "contact_form.interest_options"
    ) as unknown as Record<string, string>;
    return [
      { value: "admissions", text: opts.admissions },
      { value: "general", text: opts.general },
      { value: "tuition", text: opts.tuition },
      { value: "scholarships", text: opts.scholarships },
      { value: "therapy", text: opts.therapy },
      { value: "other", text: opts.other },
    ];
  }

  get emailValid(): boolean {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(this.form.email.trim());
  }

  get emailFeedback(): string {
    if (!this.form.email.trim()) {
      return this.$t("contact_form.required_field") as string;
    }
    return this.$t("contact_form.invalid_email") as string;
  }

  get fieldStates() {
    if (!this.triedSubmit) {
      return {
        name: null as null | boolean,
        email: null as null | boolean,
        phone: null as null | boolean,
        interest: null as null | boolean,
      };
    }
    return {
      name: this.form.name.trim().length > 0,
      email: this.emailValid,
      phone: this.form.phone.trim().length > 0,
      interest: this.form.interest !== null,
    };
  }

  get isFormValid(): boolean {
    return (
      this.form.name.trim().length > 0 &&
      this.emailValid &&
      this.form.phone.trim().length > 0 &&
      this.form.interest !== null
    );
  }

  async handleSubmit() {
    this.triedSubmit = true;
    if (!this.isFormValid) return;

    this.status = "sending";

    // Etiqueta legible del interest (en el idioma actual)
    const opts = this.$t(
      "contact_form.interest_options"
    ) as unknown as Record<string, string>;
    const interestLabel =
      (this.form.interest && opts[this.form.interest]) || this.form.interest;

    const templateParams = {
      from_name: this.form.name.trim(),
      from_email: this.form.email.trim(),
      from_phone: this.form.phone.trim(),
      interest: interestLabel,
      message: this.form.message.trim() || "(no message)",
      submitted_at: new Date().toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      }),
    };

    try {
      await emailjs.send(
        this.EMAILJS_SERVICE_ID,
        this.EMAILJS_TEMPLATE_ID,
        templateParams,
        { publicKey: this.EMAILJS_PUBLIC_KEY }
      );
      this.status = "success";
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("[ContactForm] EmailJS error:", err);
      this.status = "error";
    }
  }
}
